import { styled, Box, Flex } from "@acko-tech/building-blocks.ui.common";
import Arrow from "@public/images/icons/chevron-down.svg";
import { Text } from "@acko-tech/building-blocks.ui.typography";

export const CardContent = styled(Box)`
  padding: 0.75rem 1rem 1rem;
  box-sizing: border-box;
  ${(props) => props.styles};
`;

export const StyledText = styled.div`
  color: #36354c;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  box-sizing: border-box;
  ${(props) => props.styles}
`;

export const CarDetailValue = styled(Text)`
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  text-align: right;
  color: #040222;

  ${(props) =>
    props.emphasize &&
    `
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #040222;
  `}

  ${(props) =>
    props.isEdit &&
    `
  color: #1b73e8;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  cursor: pointer;
  `}
`;

export const CardItem = styled(Flex)`
  line-height: 17px;
  width: fit-content;
  max-width: 55%;
  ${(props) => props.styles}
`;

export const cardStyles = ({
  show,
  styles
}: {
  show?: boolean;
  styles?: any;
}) => `
background-color: ${show ? "#FFFFFF" : "#F8F7FC"};
border: ${show ? "1px solid #E7E7F0;" : "1px solid #F8F7FC"};
padding-bottom: 0px;
transition: all 0.3s cubic-bezier(0.4, 0, 1, 1) 0s;
overflow: hidden;
${styles}
`;

export const Heading = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #040222;
  ${(props) => props.styles};

  @media (min-width: 768px) {
    font-size: 16px;
    line-height: 24px;
    ${(props) => props.dwebStyles};
  }
`;

export const HeadingContainer = styled(Flex)`
  z-index: 0;
  width: space-between;
  justify-content: space-between
  align-items: center;
  background-color: #F9F6FF;
  box-sizing: border-box;
  padding:   1rem 1rem 0.75rem 1rem;
  ${(props) => props.styles};
`;

export const DisplayNameText = styled(Text)`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #5b5675;

  display: flex;
  gap: 0.5rem;
  align-items: center;

  ${(props) =>
    props.emphasize &&
    `
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #040222;
  `}

  ${(props) =>
    props.isHeading &&
    `
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    color : #040222
  `}
`;

// export const StyledArrow = styled(Arrow)`
//   margin-left: 0.68rem;
//   transform: ${(props) => (props.show ? "rotate(180deg)" : "rotate(0deg)")};
//   transition: transform 0.3s ease;

//   :hover {
//     cursor: pointer;
//   }
// `;

export const Hyperlink = styled(Text)`
  font-weight: 500;
  font-size: 14px
  line-height: 20px;
  color: #1b73e8;
  width: max-content;
  display: inline-block;

  :hover {
    cursor: pointer
  }

  ${(props) => props.styles};
`;

export const Dot = styled(Box)`
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #5b5675;
`;

export const InfoTextContainer = styled.div`
  margin-top: -0.75rem;
  color: #36354c;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  text-decoration-line: underline;
  cursor: pointer;
`;

export const SeperatorLine = styled.div`
  border-bottom: 1px solid #e7e7f0;
  width: 100%;
  margin-top: 1.25rem;
`;

export const ExpandedDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;

  &:not(:last-child) {
    border-bottom: 1px solid #e7e7f0;
    width: 100%;
    padding-bottom: 1rem;
  }
`;

export const BottomBannerContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  background-color: #efe9fb;
  padding: 6px 16px;
  border-bottom-right-radius: 12px;
  border-bottom-left-radius: 12px;
`;

export const MoreCoversTextContainer = styled.div`
  color: #1b73e8;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  cursor: pointer;
`;

export const FlexWithSeparator = styled.div`
  display: flex;
  justify-content: flex-start;
`;

export const AddonUpgradeTagContainer = styled.div`
  width: max-content;
  border-radius: 24px;
  background: rgba(251, 233, 246, 0.8);
  padding: 4px 8px;
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
  margin-top: -8px;

  :hover {
    cursor: pointer;
  }
`;

export const UpgradeText = styled.div`
  background: linear-gradient(269deg, #ee4a4a -10.35%, #743ddc 106.34%);
  background-clip: text;
  color: transparent;

  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
`;

// export const StyledRightArrow = styled(Arrow)`
//   path {
//     stroke: #c2255c;
//     stroke-width: 1px;
//   }

//   transform: rotate(-90deg);
// `;

export const LinkText = styled.span`
  color: #36354c;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-decoration-line: underline;
  cursor: pointer;
`;

export const BulletMinifiedDetails = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-top: 0.25rem;
`;

export const EditSection = styled.div`
  display: flex;
  padding: 0.75rem 1.25rem;
  justify-content: left;
  align-items: center;
  gap: 0.5rem;
  border-radius: 0px 0px 12px 12px;
  border-top: 1px solid #e7e7f0;
`;
export const FlexColContainer = styled.div`
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1rem;
  @media (min-width: 768px) {
    flex-direction: row;
  }
  :empty {
    margin-bottom: 0rem;
  }
`;

export const CustomLiItem = styled.span`
  position: relative;
  left: ${(props) => (props.isSingleItem ? "-8px" : "-4px")};
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #040222;
`;

export const LoadMore = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #040222;
  cursor: pointer;
  text-decoration: underline;
  position: absolute;
  left: 28px;
  text-underline-offset: 4px;
  left:-4px;
`;
export const PremiumDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  &:not(:last-child) {
    border-bottom: 1px solid #e7e7f0;
    width: 100%;
  }
  &:first-child {
    margin-top: -12px;
  }
  &:last-child {
    margin-bottom: -12px;
  }
`;

export const PremiumdetailWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 1rem 0;
`;

export const PremiumDetailHeading = styled(Text)`
  color: #040222;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;

export const PremiumDetailItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const PremiumDetailType = styled.div`
  color: #5b5675;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;

export const PremiumDetailValue = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: ${(props) => (props.isDiscount ? "#0FA457" : " #040222")};
  font-variant-numeric: tabular-nums;
`;

export const GrossPremiumText = styled(Text)`
  color: #040222;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
`;

export const GrossPremiumCueText = styled(Text)`
  color: #5b5675;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
`;

export const GrossPremiumAmount = styled(Text)`
  color: #040222;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
`;

export const HyperLinkText = styled(Text)`
  color: #36354c;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-decoration-line: underline;
  margin-top: 8px;
  cursor: pointer;
`;

export const CoverageDetailsText = styled(Text)`
  color: #040222;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;
